class FreebiesMeter extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            trackingMsg: this.querySelector("[data-ongoing]"),
            successMsg: this.querySelector("[data-success]"),
            progressBar: this.querySelector("[data-progress-bar]")
        };

        this.cartForm = this.querySelector('cart-form');

        this.elements.trackingMsg.innerHTML =
            this.elements.trackingMsg.innerHTML.replaceAll(
                "[remaining]",
                "<span class='text-heading-5-2' data-remaining data-no-currency></span>"
            );
        this.elements.trackingMsg.innerHTML =
            this.elements.trackingMsg.innerHTML.replaceAll(
                "[product]",
                "<span data-title></span>"
            );
    }

    static observedAttributes = ["data-cart-total", "data-cart-item-count"];

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === "data-cart-total" || name === "data-cart-item-count") {
            this.reRender();
        }
    }

    connectedCallback() {
        this.setup();
    }

    setup() {
        const cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.dataStore.listen("prices", (data) => {
            this.dataset.cartTotal = currencyAPIObj.money(data.value.original_total_price);
        });
        cartDrawer.dataStore.listen("cart", (data) => {
            this.dataset.cartItemCount = data.value.item_count;
        });
    }

    updateProgressBar() {
        const cartTotal = parseFloat(this.dataset.cartTotal);
        const cartItemCount = parseInt(this.dataset.cartItemCount) || 0;
        const stepsCount = parseInt(this.querySelector("[data-step-count]").dataset.stepCount);

        const steps = [];
        let completedSteps = 0;

        for (let i = 0; i < stepsCount; i++) {
            const stepElement = this.querySelector(`[data-step-${i}]`);
            if (stepElement) {
                const condition = stepElement.dataset.stepCondition || 'amount';
                const value = condition === 'quantity' ? 
                    parseFloat(stepElement.dataset.stepQuantity) : 
                    parseFloat(stepElement.dataset.stepAmount);
                
                // Skip empty steps (those without valid threshold values)
                if (isNaN(value) || value <= 0) {
                    continue;
                }
                
                const currentValue = condition === 'quantity' ? cartItemCount : cartTotal;
                const isCompleted = currentValue >= value;
                
                if (isCompleted) {
                    completedSteps++;
                }
                
                steps.push({ value, condition, isCompleted, currentValue });
            }
        }

        // Use the valid steps count instead of total steps count
        const validStepsCount = steps.length;
        
        // Calculate progress based on completed steps plus partial progress to next step
        let totalProgress = 0;
        
        if (validStepsCount === 0) {
            // No valid steps, no progress
            totalProgress = 0;
        } else if (completedSteps === validStepsCount) {
            // All valid steps completed
            totalProgress = 100;
        } else if (completedSteps === 0) {
            // No steps completed, show progress to first step
            const firstStep = steps[0];
            if (firstStep && firstStep.value > 0) {
                totalProgress = Math.min((firstStep.currentValue / firstStep.value) * (100 / validStepsCount), 100 / validStepsCount);
            }
        } else {
            // Some steps completed, show progress to next step
            const baseProgress = (completedSteps / validStepsCount) * 100;
            
            if (completedSteps < validStepsCount) {
                const nextStep = steps[completedSteps];
                const prevStep = steps[completedSteps - 1];
                
                if (nextStep && prevStep) {
                    const progressToNext = Math.min(
                        (nextStep.currentValue - prevStep.value) / (nextStep.value - prevStep.value),
                        1
                    );
                    const partialProgress = (progressToNext / validStepsCount) * 100;
                    totalProgress = baseProgress + partialProgress;
                }
            } else {
                totalProgress = baseProgress;
            }
        }

        totalProgress = Math.max(0, Math.min(totalProgress, 100));
        this.elements.progressBar.style.maxWidth = `${totalProgress}%`;
    }

    async updateGiftStatus(stepElement, addGift) {
        const giftId = stepElement.dataset.stepFreeGiftId;
        const stepType = stepElement.dataset.stepType;

        if (stepType === "gift" && giftId) {
            const storedGifts = JSON.parse(localStorage.getItem('addedGifts') || '[]');

            if (addGift && !storedGifts.includes(giftId)) {
                await this.cartForm.formDataAPI.updateItems({
                    id: giftId,
                    quantity: 1,
                });
                this.cartForm.reqCart();
                storedGifts.push(giftId);
                localStorage.setItem('addedGifts', JSON.stringify(storedGifts));
            } else if (!addGift && storedGifts.includes(giftId)) {
                await this.cartForm.formDataAPI.updateItems({
                    id: giftId,
                    quantity: 0,
                });
                this.cartForm.reqCart();
                const updatedGifts = storedGifts.filter(id => id !== giftId);
                localStorage.setItem('addedGifts', JSON.stringify(updatedGifts));
            }
        }
    }

    async updateCompletionStatus() {
        const cartTotal = parseFloat(this.dataset.cartTotal);
        const cartItemCount = parseInt(this.dataset.cartItemCount) || 0;
        const steps = Array.from(this.querySelectorAll('.freebies-step'));
    
        for (const step of steps) {
            const stepCondition = step.dataset.stepCondition || 'amount';
            const stepThreshold = stepCondition === 'quantity' ? 
                parseFloat(step.dataset.stepQuantity) : 
                parseFloat(step.dataset.stepAmount);
            
            // Skip empty steps (those without valid threshold values)
            if (isNaN(stepThreshold) || stepThreshold <= 0) {
                continue;
            }
            
            const currentValue = stepCondition === 'quantity' ? cartItemCount : cartTotal;
            const stepCompleted = step.classList.contains('step-completed');
    
            if (currentValue >= stepThreshold && !stepCompleted) {
                step.classList.add('step-completed');
                await this.updateGiftStatus(step, true);
            } else if (currentValue < stepThreshold && stepCompleted) {
                step.classList.remove('step-completed');
                await this.updateGiftStatus(step, false); 
            }
        }

        this.updateShippingText();
    }

    updateShippingText() {
        const cartTotal = parseFloat(this.dataset.cartTotal);
        const cartItemCount = parseInt(this.dataset.cartItemCount) || 0;
        const steps = Array.from(this.querySelectorAll('.freebies-step'));
        
        // Filter out empty steps before finding the next incomplete step
        const validSteps = steps.filter(step => {
            const stepCondition = step.dataset.stepCondition || 'amount';
            const stepThreshold = stepCondition === 'quantity' ? 
                parseFloat(step.dataset.stepQuantity) : 
                parseFloat(step.dataset.stepAmount);
            return !isNaN(stepThreshold) && stepThreshold > 0;
        });
        
        const nextStep = validSteps.find(step => !step.classList.contains('step-completed'));

        if (!nextStep) {
            this.elements.successMsg.classList.remove("!hidden");
            this.elements.trackingMsg.classList.add("hidden");
        } else {
            this.elements.successMsg.classList.add("!hidden");
            this.elements.trackingMsg.classList.remove("hidden");
            
            const stepCondition = nextStep.dataset.stepCondition || 'amount';
            const stepThreshold = stepCondition === 'quantity' ? 
                parseFloat(nextStep.dataset.stepQuantity) : 
                parseFloat(nextStep.dataset.stepAmount);
            const currentValue = stepCondition === 'quantity' ? cartItemCount : cartTotal;
            
            const remainingValue = Math.ceil(stepThreshold - currentValue);
            const remainingElement = this.elements.trackingMsg.querySelector("[data-remaining]");
            
            // Format the remaining value based on condition type
            if (stepCondition === 'quantity') {
                const itemText = remainingValue === 1 ? 'item' : 'items';
                remainingElement.textContent = `${remainingValue} ${itemText}`;
                // Ensure no currency formatting is applied
                remainingElement.setAttribute('data-no-currency', 'true');
            } else {
                if (typeof currencyAPIObj !== 'undefined') {
                    remainingElement.textContent = currencyAPIObj.formatMoney(remainingValue * 100);
                } else {
                    remainingElement.textContent = remainingValue;
                }
                // Remove the no-currency attribute for amount-based conditions
                remainingElement.removeAttribute('data-no-currency');
            }
            this.elements.trackingMsg.querySelector("[data-title]").textContent = nextStep.dataset.stepName;
        }
    }

    reRender() {
        this.updateProgressBar();
        this.updateCompletionStatus();
    }
}

customElements.define('freebies-meter', FreebiesMeter);